import {
  IListColumn,
  IFormDocument,
} from 'app/services/api5-service/api.interface';
import { IListElementCustomHeader } from 'app/services/api5-service/api.interface/list-element-custom-header.interface';

import { getFontSize } from 'common/dynamic-form/utils/get-font-size';
import { getFontWeight } from 'common/dynamic-form/utils/get-font-weight';
import { DocHelper } from 'utils/dochelper';

import { IListHeaderCellUi } from '../list-table/model';

/**
 * Get header for list
 *
 * @param doc - form doc
 * @param columns - BE columns metadata
 * @param customHeaders - Additional BE headers for table
 */
export function getListHeaderCells(
  doc: IFormDocument,
  columns: IListColumn[],
  customHeaders?: IListElementCustomHeader[],
): IListHeaderCellUi[] | undefined {
  const headerCells = columns.map(column => {
    const defaultHeader: IListHeaderCellUi = {
      columnName: column.$name,
      value: DocHelper.getMessage(`list_${column.$name}`, doc),
      horizontalAlign: column.$align || 'left',
      color: column.$color,
      size: getFontSize(column.$size),
      weight: getFontWeight(column.$weight),
    };

    const additionalHeader = customHeaders?.find(
      header => header.$name === column.$name,
    );

    if (additionalHeader) {
      defaultHeader.value = additionalHeader.$;
      defaultHeader.horizontalAlign =
        additionalHeader.$align || defaultHeader.horizontalAlign;
      defaultHeader.color = additionalHeader.$color || defaultHeader.color;
      defaultHeader.size =
        getFontSize(additionalHeader.$size) || defaultHeader.size;
      defaultHeader.weight =
        getFontWeight(additionalHeader.$weight) || defaultHeader.weight;
    }

    return defaultHeader;
  });

  const isHeaderEmpty = headerCells.every(cell => !cell.value);

  return isHeaderEmpty ? undefined : headerCells;
}
